import { render } from "./LoaderWebsite.vue?vue&type=template&id=65a631f4&scoped=true"
import script from "./LoaderWebsite.vue?vue&type=script&lang=js"
export * from "./LoaderWebsite.vue?vue&type=script&lang=js"

import "./LoaderWebsite.vue?vue&type=style&index=0&id=65a631f4&lang=scss"
import "./LoaderWebsite.vue?vue&type=style&index=1&id=65a631f4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a631f4"]])

export default __exports__